import { ApiResource } from './api/ApiResource';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export const useErrorPageRedirectIfFailed = (resource: ApiResource<any>): void => {
    const navigate = useNavigate();

    useEffect(() => {
        if (resource.status === 'error') {
            navigate('/feil');
        }
    }, [resource.status, navigate]);
};
